import { StyledNGRadioButton } from '@NGComponents/NGRadioButton/NGRadioButton.styles';
import { FC, Fragment, useCallback } from 'react';
import HotkeyTooltip from 'src/components/tooltips/HotkeyTooltip';
import { StyledDotsNavigation, StyledHotkeyTooltipContainer } from './DotsNavigation.styles';
import { IDotsNavigation } from './DotsNavigation.type';

// display a list of dots animated on currentIndex update
const DotsNavigation: FC<IDotsNavigation> = ({
	onClick,
	onChange,
	dataCy,
	isHidden = false,
	currentIndex = 0,
	nbDots,
	deactivatedIndexes,
	activatedIndexes,
	id,
	hotkeyTextBuilder,
	...otherProps
}) => {
	const handleDotClick = useCallback(
		(index: number) => {
			if (!onClick || index < 0 || index >= nbDots) {
				return;
			}

			onClick(index);
		},
		[nbDots, onClick]
	);

	const renderStyledRadioButton = useCallback(
		(index: number, isDisabled?: boolean) => (
			<StyledNGRadioButton
				key={'dot-' + index}
				data-cy={!!dataCy ? `${dataCy}-${index}` : undefined}
				onClick={!isDisabled ? () => handleDotClick(index) : undefined}
				onChange={onChange ? () => onChange(index) : undefined}
				isActive={index === currentIndex}
				isDisabled={isDisabled}
			/>
		),
		[currentIndex, dataCy, handleDotClick, onChange]
	);

	return (
		<StyledDotsNavigation isHidden={isHidden} id={id} {...otherProps}>
			{Array.from({ length: nbDots }).map((_, index) => {
				const isDisabled = activatedIndexes ? !activatedIndexes?.includes(index) : deactivatedIndexes?.includes(index);

				return (
					<Fragment key={'dot-' + index}>
						{hotkeyTextBuilder ? (
							<HotkeyTooltip text={hotkeyTextBuilder(index, nbDots)} inactive={isDisabled}>
								<StyledHotkeyTooltipContainer paddingLeft={index === 0 ? 0 : 24}>
									{renderStyledRadioButton(index, isDisabled)}
								</StyledHotkeyTooltipContainer>
							</HotkeyTooltip>
						) : (
							renderStyledRadioButton(index, isDisabled)
						)}
					</Fragment>
				);
			})}
		</StyledDotsNavigation>
	);
};

export { DotsNavigation };
